import { collection, query, where, getDocs, writeBatch } from "firebase/firestore";
import { db } from "../firebase";
import { isDriverMessage } from "./messageRole";

export const markMessagesAsRead = async (fleetId, transportOrderId, userId) => {
  try {
    let q;

    if (transportOrderId) {
      q = query(
        collection(db, "fleets", fleetId, "conversations"),
        where("read", "==", false),
        where("orderId", "==", transportOrderId)
      );
    } else {
      q = query(
        collection(db, "fleets", fleetId, "conversations"),
        where("read", "==", false),
        where("userId", "==", userId)
      );
    }

    const snapshot = await getDocs(q);
    if (snapshot.empty) return;

    const batch = writeBatch(db);
    let updates = 0;
    snapshot.forEach((docSnap) => {
      const data = docSnap.data() || {};
      if (!isDriverMessage(data)) return;
      batch.update(docSnap.ref, { read: true });
      updates += 1;
    });

    if (updates === 0) return;
    await batch.commit();
    console.log("Mensagens marcadas como lidas.");
  } catch (error) {
    console.error("Erro ao marcar mensagens como lidas:", error);
  }
};
